import { createSelector } from 'reselect';

import {
  localizedLink,
  hasUserSelector,
  localeSelector,
  eRecruitingOfferSelector,
  halloFreelancerOfferSelector,
  advertisementOfferSelector,
  marketingSolutionsOfferSelector,
  xingEventsOfferSelector,
  curriculumVitaeEditorSelector,
  coverLetterEditorSelector,
  jobApplicationTipsSelector,
  kununuOfferSelector,
} from '@xingternal/platform-layout-selectors';

const servicesSelector = createSelector(
  hasUserSelector,
  localeSelector,
  eRecruitingOfferSelector,
  halloFreelancerOfferSelector,
  advertisementOfferSelector,
  marketingSolutionsOfferSelector,
  xingEventsOfferSelector,
  curriculumVitaeEditorSelector,
  coverLetterEditorSelector,
  jobApplicationTipsSelector,
  kununuOfferSelector,
  (
    hasUser,
    locale,
    eRecruitingOffer,
    halloFreelancerOffer,
    advertisementOffer,
    marketingSolutionsOffer,
    xingEventsOffer,
    curriculumVitaeEditor,
    coverLetterEditor,
    jobApplicationTips,
    kununuOffer
  ) => {
    const isDeutsch = locale === 'de';

    return !hasUser
      ? [
          eRecruitingOffer,
          isDeutsch && halloFreelancerOffer,
          advertisementOffer,
          marketingSolutionsOffer,
          xingEventsOffer,
          curriculumVitaeEditor,
          coverLetterEditor,
          jobApplicationTips,
          kununuOffer,
        ]
          .filter(Boolean)
          .map(localizedLink(locale))
      : [];
  }
);

export { servicesSelector };
